module.exports = __webpack_public_path__ + "img/empty-boards.6d92e58e.svg";